import { connect } from 'react-redux';
import ProjectFilters from './Filters';
import { State } from 'store/state';
import { setDeveloperFilters } from 'store/state/app/actions';
import { developerFiltersSelector } from 'store/state/app/selectors';

const mapStateToProps = (state: State) => ({
  filters: developerFiltersSelector(state),
});

const mapDispatchToProps = {
  setFilters: setDeveloperFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFilters);
